module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Mary-Shelley.ca81da5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Mary-Shelley.jpg
// module id = Rikg
// module chunks = 0